module.exports = __webpack_public_path__ + "img/Type_Grass.676c1f60.png";